(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["purio-products"] && !Shopify.designMode) return;
  try {
    
  class PurioProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-purio-track]');
      this.prev = this.querySelector('[data-purio-prev]');
      this.next = this.querySelector('[data-purio-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.measure = this.measure.bind(this);
      this.prev.addEventListener('click', () => this.scrollByPage(-1));
      this.next.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', this.update);
      window.addEventListener('resize', this.measure);
      this.measure();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.measure);
    }

    measure() {
      const media = this.track.querySelector('.purio-products__media');
      if (media) this.style.setProperty('--pp-media-h', media.offsetHeight + 'px');
      this.update();
    }

    scrollByPage(direction) {
      const item = this.track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = max > 1;
      this.classList.toggle('purio-products__carousel--static', !scrollable);
      this.prev.disabled = !scrollable || this.track.scrollLeft <= 1;
      this.next.disabled = !scrollable || this.track.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('purio-products-carousel')) {
    customElements.define('purio-products-carousel', PurioProductsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
